import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SectionProps, WithRefProps } from '../types';

interface HeroSectionProps extends SectionProps, WithRefProps {
  handleCTAClick: (e: React.MouseEvent) => void;
  parallaxRef: React.RefObject<HTMLDivElement>;
  parallaxOffset: number;
}

const HeroSection: React.FC<HeroSectionProps> = ({ 
  inView, 
  forwardedRef, 
  handleCTAClick, 
  parallaxRef, 
  parallaxOffset 
}) => {
  return (
    <header id="home" className="relative text-gray-800 overflow-hidden h-screen flex items-center">
      <div
        ref={parallaxRef}
        className="absolute inset-0 z-0"
        role="img"
        aria-label="Professionelle Beratung für betriebliche Gesundheitsvorsorge und Mitarbeiterbindung"
        style={{
          backgroundImage: 'url("/images/bg dunkel.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 1,
          transform: `translateY(${parallaxOffset}px)`,
          transition: 'transform 0.1s ease-out'
        }}
      >
        <div 
          className="absolute inset-0" 
          style={{
            background: 'linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.25) 100%)'
          }}
        />
      </div>
      <div className="relative w-full z-10">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div ref={forwardedRef} className={`max-w-2xl space-y-6 hero-content p-4 md:p-0 ${inView ? 'in-view' : ''}`}>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-white">
              Werden Sie zum <span className="text-primary-500">Top Arbeitgeber</span> der Region
            </h1>
            <p className="text-base md:text-lg lg:text-xl text-white">
              Schaffen Sie ein Arbeitsumfeld, in dem sich Ihre Mitarbeiter wertgeschätzt fühlen und ihr volles Potenzial entfalten können. Mit unserem ganzheitlichen Ansatz stärken Sie die Bindung zu Ihrem Team und werden zum Wunscharbeitgeber in Ihrer Region.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={handleCTAClick}
                className="btn btn-primary btn-lg w-full sm:w-auto flex items-center justify-center gap-2 transform hover:scale-105">
                Kostenlose Potentialanalyse
                <ArrowRight size={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeroSection;